import React, { useState, useEffect, useContext, useMemo } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Redirect } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import dateFormat from "dateformat";
import Table from "react-bootstrap/Table";
import { createProjectComment, updateProject } from "../../graphql/mutations";
import { getProject } from "../../graphql/queries";
import { createProjectFile } from "../../graphql/mutations";
import { Input, notification, Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import config from "../../aws-exports";
import { Context } from "../../Store.js";
import { API, graphqlOperation, Storage } from "aws-amplify";
import "./style.css";

const ArchivedProjectDashboardPage = () => {
  const [state, dispatch] = useContext(Context);
  const [projectFiles, setProjectFiles] = useState([]);
  const [projectComments, setProjectComments] = useState([]);
  const [projectComment, setProjectComment] = useState({
    project_id: state.selectedProject.id,
    fileComment: "",
    username: state.user.username,
    createdDate: new Date(),
    isDeleted: false,
  });
  const [projectFile, setProjectFile] = useState({
    fileDescription: "",
    project_id: state.selectedProject.id,
    fileLink: "",
    username: state.user.username,
    isDeleted: false,
  });
  const [project, setProject] = useState({
    id: "",
    projectName: "",
    identificationNumber: "",
    startDate: new Date(),
    endDate: new Date(),
    projectType: "",
    abstract: "",
    uploadAbstract: "",
    status: "",
    username: "",
  });
  const [redirect, setRedirect] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const fetchProject = async () => {
    try {
      const projectData = await API.graphql(
        graphqlOperation(getProject, {
          id: state.selectedProject.id,
        })
      );
      const projectFilesList = projectData.data.getProject.projectFiles.items;
      const projectCommentList =
        projectData.data.getProject.projectComments.items;
      setProjectFiles(projectFilesList);
      setProjectComments(projectCommentList);
    } catch (error) {
      notification.error({
        message: "Error fetching projects!",
        description: error.message,
        placement: "topRight",
        duration: 1.5,
        onClose: () => {
          setRedirect(null);
          setIsLoading(false);
        },
      });
    }
  };

  const update = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    delete project.projectFiles;
    delete project.projectComments;
    project.status = "ARCHIVED";
    setProject({ ...project, status: "ARCHIVED" });
    try {
      const projectData = await API.graphql(
        graphqlOperation(updateProject, {
          input: { ...project },
        })
      );
      notification.success({
        message: "Project Archived!",
        description: "Project Successfully Archived",
        placement: "topRight",
        duration: 2.0,
        onClose: () => {
          setProject({
            projectName: "",
            identificationNumber: "",
            startDate: new Date(),
            endDate: new Date(),
            projectType: "",
            abstract: "",
            uploadAbstract: "",
            status: "false",
          });
          setIsLoading(false);
          setRedirect(`/search`);
        },
      });
    } catch (error) {
      notification.error({
        message: "Error archiving project!",
        description: error.message,
        placement: "topRight",
        duration: 10.0,
        onClose: () => {
          setRedirect(null);
          setIsLoading(false);
        },
      });
    }
  };

  useEffect(() => {
    setProject({
      id: state.selectedProject.id,
      projectName: state.selectedProject.projectName,
      identificationNumber: state.selectedProject.identificationNumber,
      startDate: state.selectedProject.startDate,
      endDate: state.selectedProject.endDate,
      projectType: state.selectedProject.projectType,
      abstract: state.selectedProject.abstract,
      uploadAbstract: state.selectedProject.uploadAbstract,
      status: state.selectedProject.status,
      username: state.selectedProject.username,
      projectFiles: state.selectedProject.projectFiles,
      projectComments: state.selectedProject.projectComments,
    });
    fetchProject();
  }, []);

  if (redirect) {
    return <Redirect to={redirect} />;
  } else {
    return (
      <React.Fragment>
        <div
          className="container inner-class-container"
          style={{ height: "100%" }}
        >
          <form>
            <fieldset>
              <legend>Project Form</legend>
              <div className="form-group">
                <label htmlFor="projectName">Project</label>
                <input
                  className="form-control"
                  id="projectName"
                  aria-describedby="emailHelp"
                  disabled
                  value={project.projectName}
                />
              </div>

              <div className="form-group">
                <label htmlFor="identificationNumber">
                  Identification Number
                </label>
                <input
                  className="form-control"
                  id="identificationNumber"
                  disabled
                  value={project.identificationNumber}
                />
              </div>

              <div className="form-group">
                <label htmlFor="startDate">Project Start Date</label>
                <input
                  className="form-control"
                  disabled
                  value={dateFormat(project.startDate, "mmmm dS, yyyy")}
                />
              </div>

              <div className="form-group">
                <label htmlFor="endDate">Project End Date</label>
                <Input
                  className="form-control"
                  disabled
                  value={dateFormat(project.endDate, "mmmm dS, yyyy")}
                />
              </div>

              <div className="form-group">
                <label htmlFor="projectType">Project Type</label>
                <input
                  className="form-control"
                  id="projectType"
                  value={project.projectType}
                  disabled
                />
              </div>
              <div className="form-group">
                <a href={project.uploadAbstract} target="_blank">
                  Click Here To View Abstract
                </a>
              </div>
            </fieldset>
          </form>
          <br />
          <h2>Project Files</h2>
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>Description</th>
                <th>View</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {projectFiles.map((item) => (
                <tr key={item.id}>
                  <td>{item.fileDescription}</td>
                  <td>
                    <a href={item.fileLink} target="_blank">
                      View
                    </a>
                  </td>
                  <td></td>
                </tr>
              ))}
            </tbody>
          </Table>

          <br />
          <br />
          <br />
          <h2>Project Comments</h2>
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>Comment</th>
                <th>Date</th>
                <th>user</th>
              </tr>
            </thead>
            <tbody>
              {projectComments.map((item) => (
                <tr key={item.id}>
                  <td>{item.fileComment}</td>
                  <td>
                    {dateFormat(item.createdDate, "mmmm dS, yyyy hh:mm:ss")}
                  </td>
                  <td>{item.username}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </React.Fragment>
    );
  }
};

export default ArchivedProjectDashboardPage;
